import React, { useState, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import FormSection from 'components/sales/formSection/formSectionNew';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { handleValidateObj } from 'constants/objValues/objvalues';
import Regex from 'services/utils/regex/Regex';
import DatePicker from 'components/sales/datePicker/datePicker';

const LeadDetails = ({
  isCorporate = false,
  inputLabel = 'label',
  isSupply = false,
  isB2bAlliances = false,
  isApartment = false,
  LeadSource,
  sourceData,
  handleValue,
  pocSiteType = null,
  pocSiteTypeData = null,
  pocSubSiteTypeData = null,
  pocSubSiteType = null,
  supDropDownData,
  corDropDownData,
  appartmentDropDown,
  b2bDropDown,
  prefilledData = null,
  isDefalut,
  client_name=null,
  isEdit=false,
}) => {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth()+1; 
  var yyyy = today.getFullYear();
  if(dd<10) {
      dd='0'+dd;
  } 
  if(mm<10) {
      mm='0'+mm;
  } 
  today = dd+'-'+mm+'-'+yyyy;

  const leadDtl = {
    name: '',
    building_name: '',
    sourceLead: { id: null, value: '' },
    tpPoc: '',
    contact_date: today,
    fmcName: '',
    occupancy: {id: null, value: ''},
    existing_setup: {id: null, value: ''},
    marquee_site: {id: null, value: ''},
    type_of_ev_charges:'',
    brand:'',
  };
  const leadSiteType = {
    typeSite: { id: null, value: '' },
    catLead: '',
  };

  const [leadDtls, setLeadDtls] = useState(leadDtl);
  const [leadsities, setLeadsities] = useState(leadSiteType);
  const [typeSubSite, setTypeSubSite] = useState({ id: null, value: '' });
  const [siteSubTypeOther, setSiteSubTypeOther] = useState('');
  const [leadSourceOther, setLeadSourceOther] = useState('');
  const [siteType, setSiteType] = useState();
  const [source, setSource] = useState();
  const [occupancy, setOccupancy] = useState();
  const [existingSetup, setExistingSetup] = useState();

  const setToDefaultValue = () => {
    if (isDefalut === true) {
      setLeadDtls(leadDtl);
      setLeadsities(leadSiteType);
      setTypeSubSite({ id: null, value: '' });
    }
  };

  useEffect(() => setToDefaultValue(), [isDefalut]);

  useEffect(() => {
    if (
      prefilledData?.lead_data !== undefined &&
      prefilledData?.lead_data !== null
    ) {
      const {
        client_name,
        building_name,
        lead_source_id,
        lead_source,
        site_type_id,
        site_type,
        site_sub_type,
        site_sub_type_id,
        other_poc_sites,
        contact_date,
        fmc_name,
        is_marquee_site,
        existing_solution,
        existing_solution_id,
        occupancy,
        occupancy_id
      } = prefilledData?.lead_data;
      setLeadDtls({
        ...leadDtls,
        name: client_name,
        building_name:building_name,
        contact_date: contact_date,
        sourceLead: { id: lead_source_id, value: lead_source },
        fmcName: fmc_name,
        existing_setup: {id: existing_solution_id, value: existing_solution},
        occupancy: {id: occupancy_id, value: occupancy},
        marquee_site: {id: (is_marquee_site == 'Yes') ? 1 : 2, value: is_marquee_site},

      });
      setLeadsities({
        ...leadsities,
        typeSite: { id: site_type_id, value: site_type },
      });
      setLeadSourceOther(other_poc_sites);
      setTimeout(() => {
        setTypeSubSite({
          id: site_sub_type_id ? site_sub_type_id : '',
          value: site_sub_type,
        });
      }, 100);
    }
  }, [prefilledData]);
  useEffect(() => {
    setLeadDtls({
      ...leadDtls,
      name: client_name,
    });
  },[client_name]);

  useEffect(() => {
    if (supDropDownData) {
      const { poc_site_types } = supDropDownData;
      setSiteType(poc_site_types);
    }
  }, [supDropDownData]);

  useEffect(() => {
    if (appartmentDropDown) {
      const { sources } = appartmentDropDown;
      setSource(sources);
    }
  }, [appartmentDropDown]);
  useEffect(() => {
    if (corDropDownData) {
      const { sources, occupancy, existing_setup } = corDropDownData;
      setSource(sources);
      setOccupancy(occupancy);
      setExistingSetup(existing_setup);
    }
  }, [corDropDownData]);
  useEffect(() => {
    if (b2bDropDown) {
      const { sources } = b2bDropDown;
      setSource(sources);
    }
  }, [b2bDropDown]);

  useEffect(() => {
    setTypeSubSite({ id: null, value: '' });
    if (pocSubSiteType && leadsities.typeSite?.id)
      (async () => await pocSubSiteType(leadsities.typeSite?.id))();
  }, [leadsities.typeSite]);

  const handleLeadData = () => {
    if (isSupply === true) {
      const leadsitiesObj = {
        name: leadDtls.name,
        building_name:  leadDtls.building_name,
        typeSite: leadsities.typeSite.id,
      };
      const isNotEmpty = handleValidateObj(leadsitiesObj);
      if (isNotEmpty !== false) {
        handleValue({
          ...leadsitiesObj,
          catLead: leadsities.catLead,
          typeSubSite: typeSubSite?.id,
          siteSubTypeOther: siteSubTypeOther,
          leadSourceOther: leadSourceOther,
        });
      } else {
        handleValue(null);
      }
    }
    if (leadDtls.sourceLead.value !== '' && isSupply === false) {
      if (isB2bAlliances && !Regex.text.test(leadDtls?.name)) {
        return false;
      }
      handleValue({
        ...leadDtls,
        sourceLead: leadDtls.sourceLead?.id,
        name: leadDtls.name,
        building_name: leadDtls.building_name,
        leadSourceOther: leadSourceOther,
        fmcName: leadDtls.fmcName,
        occupancy: leadDtls.occupancy?.id,
        existing_setup: leadDtls.existing_setup?.id,
        marquee_site: leadDtls.marquee_site?.id
      });
    } else {
      return false;
    }
  };
  useEffect(() => {
    handleLeadData();
  }, [
    leadDtls,
    prefilledData,
    typeSubSite,
    leadsities,
    siteSubTypeOther,
    leadSourceOther,
  ]);
// console.log(leadDtls);
  return (
    <FormSection title={localization.businessDetailsLabel}>
      <div className="form-ctrl-col">
      <ConstantInput
        label={inputLabel}
        type="text"
        regex={isB2bAlliances ? Regex.text.test(leadDtls?.name) : null}
        handleChange={(val) => {
          setLeadDtls({ ...leadDtls, name: val });
        }}
        required
        errorMsg={
          isB2bAlliances === ''
            ? localization.requiredClientName
            : localization.requiredCharacter
        }
        value={leadDtls.name}
        isStarRequired={true}
      />
      <ConstantInput
        label={localization.building_name}
        errorMsg={localization.isRequired}
        type="text"
        required
        isStarRequired={true}
        handleChange={(val) =>
          setLeadDtls({ ...leadDtls, building_name: val })
        }
        value={leadDtls.building_name}
      />
      <DatePicker
        label={'First Contact Date'}
        handleChange={(val) => setLeadDtls({ ...leadDtls, contact_date: val })}
        maxDate={new Date()}
        value={leadDtls.contact_date}
      />
      {isB2bAlliances === true && (
        <DropDownInput
          data={b2bDropDown && b2bDropDown.poc_site_types}
          label={localization.categoryAlliances}
          getIdValue={(val) => setLeadDtls({ ...leadDtls, tpPoc: val.id })}
          required
          errorMsg={localization.isRequired}
          // value={otherDtlData.categoryAlliances.value}
        />
      )}
      {isSupply === true ? null : (
        <Fragment>
          <DropDownInput
            label={localization.LeadSource}
            data={source}
            getIdValue={(val) => {
              setLeadDtls({
                ...leadDtls,
                sourceLead: { id: val.id, value: val.value },
              });
            }}
            required={true}
            errorMsg={localization.requiredLeadSource}
            value={leadDtls.sourceLead.value}
            isStarRequired={true}
          />
          <DropDownInput
            label={localization.occupancy}
            data={occupancy}
            getIdValue={(val) => {
              setLeadDtls({
                ...leadDtls,
                occupancy: { id: val.id, value: val.value },
              });
            }}
            // required={true}
            // errorMsg={localization.requiredLeadSource}
            value={leadDtls.occupancy.value}
          />
          <DropDownInput
            label={localization.existingSolution}
            data={existingSetup}
            getIdValue={(val) => {
              setLeadDtls({
                ...leadDtls,
                existing_setup: { id: val.id, value: val.value },
              });
            }}
            // required={true}
            value={leadDtls.existing_setup.value}
          />
          <DropDownInput
            label={localization.marqueeSite}
            data={[
              { name: 'Yes', id: 1 },
              { name: 'No', id: 2 },
            ]}
            getIdValue={(val) => {
              setLeadDtls({
                ...leadDtls,
                marquee_site: { id: val.id, value: val.value },
              });
            }}
            // required={true}
            value={leadDtls.marquee_site.value}
          />
          <ConstantInput
            label={localization.fmcName}
            // regex={Regex.text.test(leadDtls.fmcName)}
            // errorMsg={
            //   leadDtls.fmcName
            //     ? localization.requiredCharacter
            //     : localization.requiredPocName
            // }
            type="text"
            handleChange={(val) => setLeadDtls({ ...leadDtls, fmcName: val })}
            required={false}
            // isStarRequired={isSupply ? false : true}
            value={leadDtls.fmcName}
          />

          <ConstantInput
              label={localization.brand}
              type="text"
              handleChange={ (val) => {
                setLeadDtls({
                  ...leadDtls,
                  brand: val,
                })}
              }
              value={leadDtls.brand}
          />

          <DropDownInput
              label={localization.typeOfEVCharges}
              data={[{id:"Slow", name:"Slow"}, {id:"Fast", name:"Fast"}]}
              getIdValue={(val) => {
                setLeadDtls({
                  ...leadDtls,
                  type_of_ev_charges: val.id,
                });
              }}
              // required={true}
              value={leadDtls.type_of_ev_charges}
          />
          {leadDtls.sourceLead?.id === 8 && (
            <ConstantInput
              label={localization.otherLeadSource}
              type="text"
              regex={isSupply ? Regex.text.test(leadSourceOther) : null}
              handleChange={(val) => setLeadSourceOther(val)}
              required
              isStarRequired={true}
              errorMsg={localization.requiredLeadSource}
              value={leadSourceOther}
            />
          )}
        </Fragment>
      )}
      {isSupply ? (
        <Fragment>
          <DropDownInput
            label={localization.siteType}
            getIdValue={(val) => {
              setLeadsities({
                ...leadsities,
                typeSite: { id: val.id, value: val.value },
              });
            }}
            data={siteType}
            errorMsg={localization.requiredsiteType}
            required
            value={leadsities.typeSite.value}
          />
          {leadsities.typeSite?.id === 13 && (
            <DropDownInput
              label={localization.siteSubType}
              data={pocSubSiteTypeData && pocSubSiteTypeData}
              getIdValue={(val) => {
                setTypeSubSite({ id: val.id, value: val.value });
              }}
              required={true}
              errorMsg={localization.isRequired}
              value={typeSubSite.value}
            />
          )}
          {typeSubSite.id === 30 && (
            <ConstantInput
              label={localization.clientType}
              type="text"
              regex={isSupply ? Regex.text.test(siteSubTypeOther) : null}
              handleChange={(val) => setSiteSubTypeOther(val)}
              required
              isStarRequired={true}
              errorMsg={localization.requiredClientType}
              value={siteSubTypeOther}
            />
          )}
        </Fragment>
      ) : null}
      </div>
    </FormSection>
  );
};

LeadDetails.propTypes = {
  isCorporate: PropTypes.bool,
  inputLabel: PropTypes.string,
  isSupply: PropTypes.bool,
  isB2bAlliances: PropTypes.bool,
  isApartment: PropTypes.bool,
  LeadSource: PropTypes.func,
  sourceData: PropTypes.array,
  handleValue: PropTypes.func,
};

export default LeadDetails;
